var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"color":_vm.SECONDARYBLUE,"fab":"","x-small":"","depressed":""},on:{"click":_vm.goBack}},[_c('v-icon',{attrs:{"color":_vm.BRANDCOLOR}},[_vm._v("mdi-arrow-left")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }